module.exports = __webpack_public_path__ + "static/img/icon2-7.eebf5ca4.png";